'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    AdvancedPagination: ()=>AdvancedPagination
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const external_react_responsive_namespaceObject = require("react-responsive");
const index_cjs_namespaceObject = require("../../IconButton/index.cjs");
const external_Select_index_cjs_namespaceObject = require("../../Select/index.cjs");
const external_Tooltip_index_cjs_namespaceObject = require("../../Tooltip/index.cjs");
const external_BasicPagination_cjs_namespaceObject = require("./BasicPagination.cjs");
const external_utils_index_cjs_namespaceObject = require("../../../utils/index.cjs");
const external_Text_index_cjs_namespaceObject = require("../../Text/index.cjs");
const external_Label_index_cjs_namespaceObject = require("../../Label/index.cjs");
const external_Pagination_variants_cjs_namespaceObject = require("../Pagination.variants.cjs");
const AdvancedPagination = ({ rowsPerPageOptions = [
    10,
    25,
    50,
    100
], initialRowsPerPage, onRowsPerPageChange, totalRows, initialPage = 1, onPageChange, className, currentPage: currentPageProp })=>{
    const [currentPage, setCurrentPage] = (0, external_react_namespaceObject.useState)(initialPage);
    const isMobile = (0, external_react_responsive_namespaceObject.useMediaQuery)({
        maxWidth: 767
    });
    const responsiveInitialRowsPerPage = initialRowsPerPage ?? (isMobile ? rowsPerPageOptions[0] : rowsPerPageOptions[1]);
    (0, external_react_namespaceObject.useEffect)(()=>{
        if (currentPageProp) setCurrentPage(currentPageProp);
    }, [
        currentPageProp
    ]);
    const filteredRowsPerPageOptions = (0, external_react_namespaceObject.useMemo)(()=>{
        const optionsGteTotal = rowsPerPageOptions.filter((option)=>option >= totalRows);
        return optionsGteTotal.length >= 2 ? rowsPerPageOptions.filter((option)=>option <= Math.min(...optionsGteTotal)) : rowsPerPageOptions;
    }, [
        rowsPerPageOptions,
        totalRows
    ]);
    const validRowsPerPage = (0, external_react_namespaceObject.useMemo)(()=>filteredRowsPerPageOptions.includes(responsiveInitialRowsPerPage) ? responsiveInitialRowsPerPage : filteredRowsPerPageOptions[0], [
        filteredRowsPerPageOptions,
        responsiveInitialRowsPerPage
    ]);
    const totalPages = (0, external_react_namespaceObject.useMemo)(()=>Math.ceil(totalRows / validRowsPerPage), [
        totalRows,
        validRowsPerPage
    ]);
    const firstIndex = (0, external_react_namespaceObject.useMemo)(()=>(currentPage - 1) * validRowsPerPage + 1, [
        currentPage,
        validRowsPerPage
    ]);
    const lastIndex = (0, external_react_namespaceObject.useMemo)(()=>Math.min(currentPage * validRowsPerPage, totalRows), [
        currentPage,
        validRowsPerPage,
        totalRows
    ]);
    const handlePageChangeInternal = (0, external_react_namespaceObject.useCallback)((page)=>{
        setCurrentPage(page);
        onPageChange?.(page);
    }, [
        onPageChange
    ]);
    const handleFirstPageClick = (0, external_react_namespaceObject.useCallback)(()=>{
        handlePageChangeInternal(1);
    }, [
        handlePageChangeInternal
    ]);
    const handleLastPageClick = (0, external_react_namespaceObject.useCallback)(()=>{
        handlePageChangeInternal(totalPages);
    }, [
        handlePageChangeInternal,
        totalPages
    ]);
    const handleRowsPerPageChange = (0, external_react_namespaceObject.useCallback)((value)=>{
        const currentFirstIndex = (currentPage - 1) * validRowsPerPage + 1;
        const newPage = Math.ceil(currentFirstIndex / parseInt(value));
        onRowsPerPageChange(parseInt(value));
        setCurrentPage(newPage);
        onPageChange?.(newPage);
    }, [
        onRowsPerPageChange,
        onPageChange,
        currentPage,
        validRowsPerPage
    ]);
    const styles = (0, external_Pagination_variants_cjs_namespaceObject.paginationVariants)();
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        className: (0, external_utils_index_cjs_namespaceObject.cn)(styles.container(), className),
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                className: styles.pageControls(),
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Tooltip_index_cjs_namespaceObject.Tooltip, {
                        side: "top",
                        color: "neutral",
                        emphasis: true,
                        triggerNode: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.IconButton, {
                            iconName: "first_page",
                            type: "plainPrimary",
                            onClick: handleFirstPageClick,
                            disabled: currentPage <= 1,
                            "aria-label": "Go to first page"
                        }),
                        children: "First Page"
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_BasicPagination_cjs_namespaceObject.BasicPagination, {
                        showButtonLabels: false,
                        pageCountDisplay: "select",
                        initialPage: currentPage,
                        totalRows: totalRows,
                        rowsPerPage: validRowsPerPage,
                        onPageChange: handlePageChangeInternal
                    }, `${validRowsPerPage}-${currentPage}`),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Tooltip_index_cjs_namespaceObject.Tooltip, {
                        side: "top",
                        color: "neutral",
                        emphasis: true,
                        triggerNode: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.IconButton, {
                            iconName: "last_page",
                            type: "plainPrimary",
                            onClick: handleLastPageClick,
                            disabled: currentPage >= totalPages,
                            "aria-label": "Go to last page"
                        }),
                        children: "Last Page"
                    })
                ]
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                className: styles.pageInfo(),
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_Label_index_cjs_namespaceObject.Label, {
                        className: styles.indexLabel(),
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_Text_index_cjs_namespaceObject.Span, {
                                className: "font-bold",
                                children: [
                                    firstIndex,
                                    "-",
                                    lastIndex
                                ]
                            }),
                            "of",
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Text_index_cjs_namespaceObject.Span, {
                                className: "font-bold",
                                children: totalRows
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                        className: styles.pageSizeControls(),
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Label_index_cjs_namespaceObject.Label, {
                                children: "Rows per page"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Select_index_cjs_namespaceObject.Select, {
                                label: "",
                                placeholder: "Rows Per Page",
                                menuItems: filteredRowsPerPageOptions.map((value)=>({
                                        label: value.toString(),
                                        value: value.toString()
                                    })),
                                initialValue: validRowsPerPage.toString(),
                                value: validRowsPerPage.toString(),
                                onChange: handleRowsPerPageChange,
                                className: "w-24"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
exports.AdvancedPagination = __webpack_exports__.AdvancedPagination;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "AdvancedPagination"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
